import { useEffect, useState } from 'react';

/**
 * Dưới `sm` (640px) — điện thoại dựng đứng.
 *
 * Đo **cửa sổ**, không đo container: câu hỏi là "đây có phải điện thoại không".
 * Ở ngăn chọn dự án, thanh bên chính là thứ làm container đổi bề rộng — đo
 * container thì quyết định ẩn thanh bên tự làm đổi chính số đo của nó.
 *
 * Cùng mốc với tiền tố `max-sm:` của Tailwind. Dùng hook khi bản điện thoại
 * **đổi cấu trúc** (bảng thành danh sách thẻ, Gantt bỏ cột) — chỉ đổi khoảng
 * cách, cỡ chữ thì `max-sm:` là đủ và không cần JavaScript.
 *
 * Không có `matchMedia` (jsdom của test) ⇒ coi là màn rộng, tức bố cục mặc định
 * mà các spec vốn được viết cho.
 */
const NARROW_QUERY = '(max-width: 639px)';

export function useNarrowScreen(): boolean {
  const [narrow, setNarrow] = useState(
    () => typeof window !== 'undefined' && !!window.matchMedia?.(NARROW_QUERY).matches,
  );
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia(NARROW_QUERY);
    const onChange = (): void => setNarrow(query.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);
  return narrow;
}
